'use strict';

exports.__esModule = true;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _schemaPhysician = require('./schema-physician');

var _schemaPhysician2 = _interopRequireDefault(_schemaPhysician);

var _schemaPractice = require('./schema-practice');

var _schemaPractice2 = _interopRequireDefault(_schemaPractice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SchemaGenerator = function (_React$Component) {
	(0, _inherits3.default)(SchemaGenerator, _React$Component);

	function SchemaGenerator(props) {
		(0, _classCallCheck3.default)(this, SchemaGenerator);
		return (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	}

	SchemaGenerator.prototype.render = function render() {

		switch (this.props.type) {

			case "physician":
				return _react2.default.createElement(_schemaPhysician2.default, { specialistData: this.props.specialistData, reviewData: this.props.reviewData, specialistPracticesData: this.props.specialistPracticesData });
				break;

			case "practice":
				return _react2.default.createElement(_schemaPractice2.default, { practiceData: this.props.practiceData, reviewData: this.props.reviewData });
				break;

			default:

				return "";
				break;
		}
	};

	return SchemaGenerator;
}(_react2.default.Component);

exports.default = SchemaGenerator;


SchemaGenerator.displayName = 'SchemaGenerator';

SchemaGenerator.propTypes = {};

SchemaGenerator.defaultProps = {
	renderMode: "json",
	specialistData: { "uri_id": null },
	specialistPracticesData: { "uri_id": null },
	reviewData: { "aggregate_review": -1 },
	practiceData: { "uri_id": null }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/schema-generator/lib/components/schema-generator-component.js
// module id = 2353
// module chunks = 0